import React from 'react';
import PropTypes from 'prop-types';

import { Label } from '@sopranodesign/pulse-components';
import { TemplatingTextArea } from '@sopranodesign/pulse-templating';

import { useComposer } from '../../../../hooks/index';

const ProgressInput = ({
  rtl = 'ltr'
}) => {
  const {
    response: { content },
    dispatch
  } = useComposer();

  const handleResponseChange = value => {
    dispatch({
      type: 'UPDATE_CONTENT',
      newContent: { text: value }
    });
  };

  return (
    <div>
      <Label htmlFor="standard">Message</Label>
      <TemplatingTextArea
        rtl={rtl}
        id="standard"
        name="standard"
        value={content.text}
        onChange={handleResponseChange}
      />
    </div>
  );
};

ProgressInput.propTypes = {
  rtl: PropTypes.oneOf(['rtl', 'ltr'])
};

export default ProgressInput;
